<template>
  <div class="">

    <template v-if="applicants != null">

      <!-- First show the PRIMARY applicant at the top -->
      <template v-for="(applicant, index) in applicants">
        <template v-if="applicant.person != null && applicant.person.isPrimary == 1">
          <div class="px-2 py-1 border-b">
            <router-link 
              :to="{
                name  : $route.name,
                params: {
                  clientId   : applicant.client_id,
                  applicantId: applicant.id
                }
              }"
              tag="a" 
              class="no-underline block overflow-hidden">

              <div class="text-green-500 text-xs">Primary Applicant</div>
              <div :class="{ 'text-sm text-blue-500 hover:underline' : true, 'font-semibold' : $route.params.applicantId == applicant.id }" 
                style="margin-right:25px;">{{ getApplicantName(applicant) }}</div>
            </router-link>
          </div>
        </template>
      </template>

      <!-- 
          Apply vue draggable
          Allow people drag and drop to sort applicants so that they can
          make them a primary applicant
      -->
      <draggable v-model="applicants">
        <template v-for="(applicant, index) in applicants">
          <template v-if="applicant.person == null || applicant.person.isPrimary == 0">
            <div class="px-2 py-1 border-b">
              <router-link 
                :to="{
                  name  : $route.name,
                  params: {
                    clientId   : applicant.client_id,
                    applicantId: applicant.id
                  }
                }"
                tag="a" 
                class="no-underline block">

                <div class="font-medium text-xs text-gray-700">
                  <template v-if="applicant.person != null">Applicant</template>
                  <template v-if="applicant.company != null">Company</template>
                  <template v-if="applicant.trust != null">Trust</template>
                </div>

                <div class="overflow-hidden">
                  <div class="float-right" v-if="$route.path.indexOf('applicant/') > -1">
                    <a href="#" 
                      class="text-gray-500 hover:text-red-500 text-sm" 
                      v-on:click.prevent="deleteApplicant(applicant.id)"
                      v-tooltip.top="'Delete this applicant'">
                      <svg width="16" height="16" stroke-width="3" class="align-middle" stroke="currentColor" fill="none">
                        <use xlink:href="/static/img/feather-sprite.svg#x"/>
                      </svg>
                    </a>
                  </div>

                  <div 
                    :class="{ 'text-sm text-blue-500 hover:underline' : true, 'font-semibold' : $route.params.applicantId == applicant.id }" 
                    style="margin-right:25px;">{{ getApplicantName(applicant) }}</div>
                </div>
              </router-link>
            </div>
          </template>
        </template>
      </draggable>
    </template>
  </div>
</template>

<script>
  import draggable    from 'vuedraggable'
  import { EventBus } from '@/shared/event-bus'

  export default {

    components: {
      draggable,
    },

    data() {
      return {
        client : null
      }
    },

    created() {
      this.getClient({
        clientId : this.$route.params.clientId
      }, (client) => {
        this.client = client
      })
    },

    mounted() {

      // at times client and its applicants might be updated
      // so let's send an event so that we can just reload
      EventBus.$on('update-client', () => {
        this.prepare()
      });
    },

    computed : {

      // applicants are from client.applicants - list of applicants under the given client
      // client is stored in the store, which cannot be mutated outside of vuex,
      // so we are going to provide get/set pairs to make the change
      applicants : {
        get() {
          return this.$store.state[this.$store.state.view + 'Module'].client.applicants
        },

        set(value) {
          this.$store.commit(this.$store.state.view + "Module/setApplicants", value)

          let applicantIds = []
          for(let i=0; i < this.$store.state[this.$store.state.view + 'Module'].client.applicants.length; i++) {
            applicantIds.push(this.$store.state[this.$store.state.view + 'Module'].client.applicants[i].id)
          }

          // make an ajax request to change the ordering of the applicants to the backend
          EventBus.$emit('set-autosave', true)
          this.apiPost({
            clientId: this.$route.params.clientId,
            applicantIds            
          }, 'client/update-applicant-order', () => {
            EventBus.$emit('set-autosave', false)
          })
        }
      }
    },

    methods : {
      deleteApplicant(applicantId) {
        this.$modal.show('confirm-modal', {
          // width : 600,
          title  : "Please confirm your action",
          message: "Are you sure you want to delete this applicant?",
          buttons:[{
            label          : 'Yes',
            color          : 'red',
            loadingViaLocal: true, // a bit of HACK, we want to show loading image when button is clicked, but hard to pass loading prop to a modal
            action         : () => {
              this.apiDelete({
                clientId   : this.$route.params.clientId,
                applicantId: applicantId
              }, 'applicant/delete', () => {
                EventBus.$emit('notification-event', {
                  'type'   : 'success',
                  'message': "Applicant deleted successfully"
                })

                this.getClient({
                  force   : true,
                  clientId: this.$route.params.clientId
                }, (client) => {
                  this.client = client

                  // once this is set, we can take the user to the primary applicant's profile page
                  this.$router.push({ 
                    name  : 'application-applicant-profile',
                    params: {
                      clientId   : this.$route.params.clientId,
                      applicantId: this.client.applicants[0].id
                    }
                  })
                })

                this.$modal.hide('confirm-modal')
              })
            }
          }, {
            label : 'No',
            color : 'gray',
            action: () => {
              this.$modal.hide('confirm-modal')
            }
          }]
        })
      },
    }
  }
</script>